<template>
  <div class="forms__field-wrapper" :class="extraClasses">
    <p class="field-description" v-if="fieldData.description" v-html="fieldData.description"/>
    <div class="input-wrapper form-element__wrapper"
      :class="{ 'error': showEmailError,  'required': required }">
      <input
        class="input"
        type="email"
        :placeholder="label"
        :id="id"
        :required="required"
        :disabled="mainEmailFieldAndLoggedIn"
        v-model="value"
        @blur="validateField"
      />
      <label class="floating-label" :for="id">{{ label }}</label>
      <p class="forms__error-message"
        v-t="'errors.required_field'"
        v-if="showFormError"
        role="alert"/>
      <p class="forms__error-message"
        v-t="'errors.invalid_email'"
        v-if="!validEmailAddress"
        role="alert"/>
    </div>
    <a :href="logoutOfCRM"
        class="already-logged-in"
        v-if="mainEmailFieldAndLoggedIn"
        v-t="{ path: 'register.not_this_user', args: { name: user.userDetails.personEmail }}"/>
  </div>
</template>

<script>
import AbstractField from "@/util/AbstractField";
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  name: "input-email",
  mixins: [AbstractField],
  data() {
    return {
      value: "",
    };
  },
  watch: {
    "$store.state.user.userLoggedIn": function (newValue, oldValue) {
      if (this.fieldData.crm_id == "Email") {
        this.value = this.user.userDetails.personEmail;
      }
    },
  },
  created() {
    if (this.mainEmailFieldAndLoggedIn) {
      this.value = this.user.userDetails.personEmail;
    }
  },
  computed: {
    showEmailError() {
      return !this.validEmailAddress || this.showFormError;
    },
    mainEmailFieldAndLoggedIn() {
      // If the user is logged in, and this is the primary email address for registering
      // then disable the field
      if (this.fieldData.crm_id == "Email" && this.isLoggedIn) {
        return true;
      } else {
        return false;
      }
    },
    logoutOfCRM() {
      let backend = process.env.VUE_APP_WK_CRM_URL;

      return (
        backend +
        "/oauth/logout?redirect=" + window.location.href
      );
    },
    validEmailAddress() {
      // Validate email on input update so we can check validity of email format
      if(this.value === undefined || this.value.length == 0) return true;
      // Taken from: https://vuejs.org/v2/cookbook/form-validation.html#Using-Custom-Validation
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.value);
    },
    ...mapState(["user"]),
    ...mapGetters(["isLoggedIn"])
  },
  methods: {
    ...mapActions(["updateUserLoggedIn"]),
  },
};
</script>